var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Button, Table } from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import moment from "moment";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { WebSocketMessage } from "../../serverConnection";
var OrderTableAgent = /** @class */ (function (_super) {
    __extends(OrderTableAgent, _super);
    function OrderTableAgent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { activeFilter: false };
        _this.toggleFilter = function () { return _this.setState({ activeFilter: !_this.state.activeFilter }); };
        _this.onDismissClick = function (id) {
            _this.props.send(WebSocketMessage("orders", "update", { id: id, status: "inactive" }));
        };
        _this.onApproveClick = function (id, email) {
            _this.props.send(WebSocketMessage("orders", "update", { id: id, status: "approved" }));
            var user = _this.props.users.valueSeq().find(function (u) { return u.email === email; });
            _this.props.send(WebSocketMessage("users", "invite", user));
        };
        return _this;
    }
    OrderTableAgent.prototype.render = function () {
        var _this = this;
        var id = this.props.currentUser.id;
        var ords = this.props.orders.map(function (o) { return (__assign(__assign({}, o), { customer: _this.props.users.get(o.user) })); });
        var orders = ords
            .filter(function (order) {
            return order.agent === id;
        })
            .sort(function (o, p) {
            var _a, _b;
            if (!o.customer) {
                return -1;
            }
            if (!p.customer) {
                return 1;
            }
            return (_a = o.customer) === null || _a === void 0 ? void 0 : _a.company.localeCompare((_b = p.customer) === null || _b === void 0 ? void 0 : _b.company);
        })
            .map(function (order) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return (React.createElement("tr", { key: order.id },
                React.createElement("td", null, order.id),
                React.createElement("td", null, (_b = (_a = order.customer) === null || _a === void 0 ? void 0 : _a.firstName) !== null && _b !== void 0 ? _b : "",
                    " ", (_d = (_c = order.customer) === null || _c === void 0 ? void 0 : _c.lastName) !== null && _d !== void 0 ? _d : ""),
                React.createElement("td", null,
                    React.createElement("b", null, (_f = (_e = order.customer) === null || _e === void 0 ? void 0 : _e.company) !== null && _f !== void 0 ? _f : "???"),
                    React.createElement("br", null), (_h = (_g = order.customer) === null || _g === void 0 ? void 0 : _g.address) !== null && _h !== void 0 ? _h : "",
                    React.createElement("br", null), (_k = (_j = order.customer) === null || _j === void 0 ? void 0 : _j.city) !== null && _k !== void 0 ? _k : ""),
                React.createElement("td", null,
                    Number(order.monthly.amount).toFixed(2),
                    " ",
                    order.monthly.currency),
                order.discount === null ? React.createElement("td", null, "-") : React.createElement("td", null,
                    order.discount,
                    " %"),
                React.createElement("td", null, order.locations),
                React.createElement("td", null,
                    order.length,
                    " Months"),
                React.createElement("td", null, moment(order.start).format("L") + " - " + moment(order.end).format("L")),
                order.premium ? React.createElement("td", { className: "green-text" }, "Premium") : React.createElement("td", { className: "red-text" }, "No Extras"),
                order.status === "pending" ? (React.createElement("td", { className: "orange-text text-darken-2" }, "Pending")) : order.status === "inactive" ? (React.createElement("td", { className: "red-text" }, "Inactive")) : order.status === "approved" ? (React.createElement("td", { className: "green-text text-lighten-1" }, "Approved")) : (React.createElement("td", { className: "green-text text-darken-2" }, "Active")),
                React.createElement("td", null,
                    React.createElement(IconButton, { onClick: function () { return order.customer && _this.onApproveClick(order.id, order.customer.email); } },
                        React.createElement(Icon, null, "check"))),
                React.createElement("td", null,
                    React.createElement(IconButton, { onClick: function () { return _this.onDismissClick(order.id); } },
                        React.createElement(Icon, null, "clear"))),
                React.createElement("td", null,
                    React.createElement(Link, { to: "/orders/edit/" + order.id },
                        React.createElement(Icon, null, "edit")))));
        });
        return (React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col s12 m12 l12" },
                React.createElement("h5", { className: "" }, "Orders"),
                React.createElement("br", null),
                React.createElement(Button, { onClick: function () { return _this.toggleFilter(); }, className: "teal white-text" }, this.state.activeFilter ? "Show all orders" : "Only show active orders"),
                React.createElement("br", null),
                React.createElement("div", { className: "card-panel" },
                    React.createElement(Table, null,
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, "No."),
                                React.createElement("th", null, "Contact"),
                                React.createElement("th", null, "Customer"),
                                React.createElement("th", null, "Monthly Amount"),
                                React.createElement("th", null, "Discount"),
                                React.createElement("th", null, "Locations"),
                                React.createElement("th", null, "Length"),
                                React.createElement("th", null, "Period"),
                                React.createElement("th", null, "Extras"),
                                React.createElement("th", null, "Status"),
                                React.createElement("th", null),
                                React.createElement("th", null),
                                React.createElement("th", null))),
                        React.createElement("tbody", null, orders))))));
    };
    return OrderTableAgent;
}(Component));
export default OrderTableAgent;



//////////////////
// WEBPACK FOOTER
// ./src/components/orders/OrderTableAgent.tsx
// module id = 1242
// module chunks = 0